// src/pages/PasswordChangePage.js
import React, { useState,useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../authcontext/authContext";
import "./PasswordChangePage.css";

const Passchange = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [allpass, setAllpass] = useState({old:"", new:"", con:""})



  const navigate = useNavigate()
  const { passupdate } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
     setAllpass({currentPassword,newPassword,confirmPassword})
     console.log(allpass, "all")
    if (!currentPassword || !newPassword || !confirmPassword) {
      setMessage("Please fill in all fields.");
      return;
    }

    if (newPassword.length < 8) {
      setMessage("Password must be at least 8 characters long.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    e.preventDefault();
    try {
      await passupdate({newPassword:newPassword});
      navigate("/login")
    } catch (error) {
      alert("fill in details properly")
    }

    setLoading(true);
    setMessage("");

    setTimeout(() => {
      setLoading(false);
      setMessage("Password changed successfully!");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    }, 2000); // Simulate an API call
  };

  return (
    <div className="center-container">
    <div className="password-change-page">
      <form className="password-form" onSubmit={handleSubmit}>
        <h2>Change Password</h2>
        {message && <div className="message">{message}</div>}
        <div className="form-group">
          <label>Current Password</label>
          <input
            type="text"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            placeholder="Enter your current password"
            required
          />
        </div>
        <div className="form-group">
          <label>New Password</label>
          <input
            type="text"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Enter a new password"
            required
          />
        </div>
        <div className="form-group">
          <label>Confirm Password</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm your new password"
            required
          />
        </div>
        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? "Changing..." : "Change Password"}
        </button>
      </form>
    </div>
    </div>
  );
};

export default Passchange;
